// react imports
import { useState, useEffect } from "react";

// react router imports
import { useNavigate } from "react-router-dom";

// @mui material components
import { Grid, Card, Icon, Divider, Radio, NativeSelect } from "@mui/material";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

// notistack imports
import { useSnackbar } from "notistack";

// Material Dashboard 2 React context
import { useMaterialUIController, setOrderPage } from "context";

// Firebase imports
import { updateDoc, doc } from "firebase/firestore";
import { db } from "../../Firebase";

function Edit() {
  const [controller, dispatch] = useMaterialUIController();
  const { orderpage, currentStudy, canEdit } = controller;

  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();

  const [notEdited, setNotEdited] = useState(true);
  const [country, setCountry] = useState(orderpage.shippingAddress.country);
  // const [countryError, setCountryError] = useState(false);
  const [isInternational, setIsInternational] = useState(
    orderpage.shippingAddress.country !== "United States"
  );
  const [attn, setAttn] = useState(orderpage.shippingAddress.attn);
  // const [attnError, setAttnError] = useState(false);
  const [email, setEmail] = useState(orderpage.shippingAddress.email);
  // const [emailError, setEmailError] = useState(false);
  const [phone, setPhone] = useState(orderpage.shippingAddress.phone);
  // const [phoneError, setPhoneError] = useState(false);
  const [clinic, setClinic] = useState(orderpage.shippingAddress.clinic);
  // const [clinicError, setClinicError] = useState(false);
  const [addressLine1, setAddressLine1] = useState(orderpage.shippingAddress.addressLine1);
  // const [addressLine1Error, setAddressLine1Error] = useState(false);
  const [addressLine2, setAddressLine2] = useState(orderpage.shippingAddress.addressLine2);
  // const [addressLine2Error, setAddressLine2Error] = useState(false);
  const [addressLine3, setAddressLine3] = useState(orderpage.shippingAddress.addressLine3);
  // const [addressLine3Error, setAddressLine3Error] = useState(false);
  const [city, setCity] = useState(orderpage.shippingAddress.city);
  // const [cityError, setCityError] = useState(false);
  const [state, setState] = useState(orderpage.shippingAddress.state);
  // const [stateError, setStateError] = useState(false);
  const [zip, setZip] = useState(orderpage.shippingAddress.zip);
  // const [zipError, setZipError] = useState(false);

  const [clinicName, setClinicName] = useState(orderpage.customization.clinicName);
  const [line2, setLine2] = useState(orderpage.customization.line2);
  const [line3, setLine3] = useState(orderpage.customization.line3);

  const itemArray = orderpage.items.map((x) => [x.image, x.title]);
  const itemListArray = orderpage.items.map((x) => [
    x.title,
    x.title,
    x.cartQuantity,
    x.quantityOptions,
    x.language,
    x.willCustomize,
  ]);

  useEffect(() => {
    console.log(notEdited);
  }, [notEdited]);

  const avatars = (members) =>
    members.map(([image, key]) => (
      <Grid item key={key} xs={4}>
        {/* <MDAvatar src={image} alt="name" size="lg" variant="square" />
         */}
        <MDBox
          component="img"
          src={image}
          alt={key}
          borderRadius="lg"
          shadow="md"
          width="100%"
          height="100%"
          position="relative"
          zIndex={1}
        />
      </Grid>
    ));

  const itemBreakdown = (list) =>
    list.map(([key, title, quantity, quantityOptions, language, customized]) => (
      <Grid item xs={6}>
        <MDTypography key={key} variant="body1" sx={{ fontSize: ".75rem" }}>
          <strong>{title}:</strong>
          <br />
          Quantity:{" "}
          <NativeSelect
            onChange={(e) => {
              console.log(e.target.value);
              const updatedQuantity = orderpage.items.map((x) =>
                x.title === title ? { ...x, cartQuantity: Number(e.target.value) } : x
              );
              const newOrderPage = { ...orderpage, items: updatedQuantity };
              setOrderPage(dispatch, newOrderPage);
              setNotEdited(false);
            }}
            defaultValue={quantity}
            inputProps={{
              name: "quantity",
              id: "uncontrolled-native",
            }}
          >
            {quantityOptions.map((x) => (
              <option value={x}>{x}</option>
            ))}
          </NativeSelect>
          <br />
          Version: {language}
          <br />
          Customized: {customized ? <p style={{ color: "green", display: "inline" }}>Yes</p> : "No"}
          <br />
          --
        </MDTypography>
      </Grid>
    ));

  const saveOrder = async () => {
    await updateDoc(doc(db, `${orderpage.storeData.study}_ORDERS`, orderpage.id), orderpage);
    const variant = "success";
    enqueueSnackbar(`${orderpage.orderId}'s has been updated!`, {
      variant,
      autoHideDuration: 2000,
    });
    navigate("/");
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12} sm={6}>
            <Card>
              {canEdit ? (
                <>
                  <MDBox
                    mx={2}
                    mt={-3}
                    py={3}
                    px={2}
                    variant="gradient"
                    bgColor="info"
                    borderRadius="lg"
                    coloredShadow="info"
                  >
                    <MDTypography variant="h6" color="white">
                      Order {orderpage.orderId}
                    </MDTypography>
                  </MDBox>
                  <Card sx={{ height: "100%", boxShadow: "none" }}>
                    <MDBox py={2} px={2}>
                      <MDBox py={2}>
                        <MDButton
                          variant="outlined"
                          color="secondary"
                          size="small"
                          onClick={() => {
                            navigate(`/${currentStudy}`);
                          }}
                        >
                          <Icon>arrow_back_ios</Icon>
                        </MDButton>
                      </MDBox>
                      <Grid container spacing={3}>
                        {avatars(itemArray)}
                      </Grid>
                    </MDBox>
                    <MDBox pb={2} px={2}>
                      <MDBox py={2} px={2} borderRadius={5}>
                        <MDTypography variant="h6">Order Summary</MDTypography>
                        <Grid container spacing={3}>
                          {itemBreakdown(itemListArray)}
                        </Grid>
                      </MDBox>
                    </MDBox>
                    <MDBox pb={2} px={2}>
                      <Grid container spacing={2}>
                        <Grid item xs={12}>
                          <MDBox py={2} px={2} borderRadius={5} bgColor="light">
                            <MDTypography variant="h6">Shipping Information</MDTypography>
                            <MDTypography variant="body2" sx={{ fontSize: ".75rem" }}>
                              <MDBox p={2}>
                                {/* {attnError && (
                                  <MDTypography variant="caption" color="error">
                                    Please enter an ATTN to.
                                  </MDTypography>
                                )} */}
                                <MDInput
                                  type="text"
                                  label="Attention to"
                                  value={attn}
                                  inputProps={{ maxLength: 35 }}
                                  onChange={(e) => {
                                    setAttn(e.target.value);
                                    setNotEdited(false);
                                  }}
                                  style={{ width: "100%" }}
                                />
                              </MDBox>
                              <MDBox p={2}>
                                {/* {attnError && (
                                  <MDTypography variant="caption" color="error">
                                    Please enter an ATTN to.
                                  </MDTypography>
                                )} */}
                                <MDInput
                                  type="text"
                                  label="Email"
                                  value={email}
                                  inputProps={{ maxLength: 35 }}
                                  onChange={(e) => {
                                    setEmail(e.target.value);
                                    setNotEdited(false);
                                  }}
                                  style={{ width: "100%" }}
                                />
                              </MDBox>
                              <MDBox p={2}>
                                {/* {attnError && (
                                  <MDTypography variant="caption" color="error">
                                    Please enter an ATTN to.
                                  </MDTypography>
                                )} */}
                                <MDInput
                                  type="text"
                                  label="Phone #"
                                  value={phone}
                                  inputProps={{ maxLength: 35 }}
                                  onChange={(e) => {
                                    setPhone(e.target.value);
                                    setNotEdited(false);
                                  }}
                                  style={{ width: "100%" }}
                                />
                              </MDBox>
                              <MDBox p={2}>
                                <MDTypography variant="caption">Select Country:</MDTypography>
                                <Radio
                                  checked={country === "United States"}
                                  onChange={(e) => {
                                    setCountry(e.target.value);
                                    // setCountryError(false);
                                    setIsInternational(false);
                                    setNotEdited(false);
                                  }}
                                  value="United States"
                                  name="radio-buttons"
                                  inputProps={{ "aria-label": "United States" }}
                                />
                                <MDTypography variant="caption">United States</MDTypography>
                                <Radio
                                  checked={country !== "United States"}
                                  onChange={() => {
                                    setCountry("");
                                    setIsInternational(true);
                                    setNotEdited(false);
                                  }}
                                  value="International"
                                  name="radio-buttons"
                                  inputProps={{ "aria-label": "International" }}
                                />
                                <MDTypography variant="caption">International</MDTypography>
                              </MDBox>
                              <MDBox p={2}>
                                {/* {countryError && (
                                  <MDTypography variant="caption" color="error">
                                    Please enter a Country.
                                  </MDTypography>
                                )} */}
                                {isInternational && (
                                  <MDInput
                                    type="text"
                                    label="Country Name"
                                    value={country}
                                    inputProps={{ maxLength: 35 }}
                                    onChange={(e) => {
                                      setCountry(e.target.value);
                                      setNotEdited(false);
                                    }}
                                    style={{ width: "100%" }}
                                  />
                                )}
                              </MDBox>
                              <MDBox p={2}>
                                {/* {clinicError && (
                                  <MDTypography variant="caption" color="error">
                                    Please enter a clinic name.
                                  </MDTypography>
                                )} */}
                                <MDInput
                                  type="text"
                                  label="Clinic Name"
                                  value={clinic}
                                  inputProps={{ maxLength: 35 }}
                                  onChange={(e) => {
                                    setClinic(e.target.value);
                                    setNotEdited(false);
                                  }}
                                  style={{ width: "100%" }}
                                />
                              </MDBox>
                              <MDBox p={2}>
                                {/* {addressLine1Error && (
                                  <MDTypography variant="caption" color="error">
                                    Please enter an address.
                                  </MDTypography>
                                )} */}
                                <MDInput
                                  type="text"
                                  label="Address Line 1"
                                  value={addressLine1}
                                  inputProps={{ maxLength: 35 }}
                                  onChange={(e) => {
                                    setAddressLine1(e.target.value);
                                    setNotEdited(false);
                                  }}
                                  style={{ width: "100%" }}
                                />
                              </MDBox>
                              <MDBox p={2}>
                                {/* {addressLine2Error && (
              <MDTypography variant="caption" color="error">
                Please enter an address.
              </MDTypography>
            )} */}
                                <MDInput
                                  type="text"
                                  label="Address Line 2"
                                  value={addressLine2}
                                  inputProps={{ maxLength: 35 }}
                                  onChange={(e) => {
                                    setAddressLine2(e.target.value);
                                    setNotEdited(false);
                                  }}
                                  style={{ width: "100%" }}
                                />
                              </MDBox>
                              <MDBox p={2}>
                                {/* {addressLine3Error && (
              <MDTypography variant="caption" color="error">
                Please enter an address.
              </MDTypography>
            )} */}
                                <MDInput
                                  type="text"
                                  label="Address Line 3"
                                  value={addressLine3}
                                  inputProps={{ maxLength: 35 }}
                                  onChange={(e) => {
                                    setAddressLine3(e.target.value);
                                    setNotEdited(false);
                                  }}
                                  style={{ width: "100%" }}
                                />
                              </MDBox>
                              <MDBox p={2}>
                                {/* {cityError && (
                                  <MDTypography variant="caption" color="error">
                                    Please enter a city.
                                  </MDTypography>
                                )} */}
                                <MDInput
                                  type="text"
                                  label="City"
                                  value={city}
                                  inputProps={{ maxLength: 35 }}
                                  onChange={(e) => {
                                    setCity(e.target.value);
                                    setNotEdited(false);
                                  }}
                                  style={{ width: "100%" }}
                                />
                              </MDBox>
                              <MDBox p={2}>
                                {/* {stateError && (
                                  <MDTypography variant="caption" color="error">
                                    Please enter a State/Province.
                                  </MDTypography>
                                )} */}
                                <MDInput
                                  type="text"
                                  label="State/Province"
                                  value={state}
                                  inputProps={{ maxLength: 35 }}
                                  onChange={(e) => {
                                    setState(e.target.value);
                                    setNotEdited(false);
                                  }}
                                  style={{ width: "100%" }}
                                />
                              </MDBox>
                              <MDBox p={2}>
                                {/* {zipError && (
                                  <MDTypography variant="caption" color="error">
                                    Please enter a postal code.
                                  </MDTypography>
                                )} */}
                                <MDInput
                                  type="text"
                                  label="Postal Code"
                                  value={zip}
                                  inputProps={{ maxLength: 35 }}
                                  onChange={(e) => {
                                    setZip(e.target.value);
                                    setNotEdited(false);
                                  }}
                                  style={{ width: "100%" }}
                                />
                              </MDBox>
                            </MDTypography>
                          </MDBox>
                        </Grid>
                        <Grid item xs={12}>
                          <MDBox py={2} px={2} borderRadius={5}>
                            <MDTypography variant="h6">Customizations</MDTypography>
                            {orderpage.customization.customized === false ? (
                              <MDTypography variant="body2" sx={{ fontSize: ".75rem" }}>
                                No Customizations
                              </MDTypography>
                            ) : (
                              <>
                                <MDBox p={2}>
                                  <MDInput
                                    type="text"
                                    label={clinicName}
                                    value={clinicName}
                                    inputProps={{ maxLength: 25 }}
                                    onChange={(e) => {
                                      setClinicName(e.target.value);
                                      setNotEdited(false);
                                    }}
                                    style={{ width: "100%" }}
                                  />
                                </MDBox>
                                <MDBox p={2}>
                                  <MDInput
                                    type="text"
                                    label={line2}
                                    value={line2}
                                    inputProps={{ maxLength: 25 }}
                                    onChange={(e) => {
                                      setLine2(e.target.value);
                                      setNotEdited(false);
                                    }}
                                    style={{ width: "100%" }}
                                  />
                                </MDBox>
                                <MDBox p={2}>
                                  <MDInput
                                    type="text"
                                    label={line3}
                                    value={line3}
                                    inputProps={{ maxLength: 25 }}
                                    onChange={(e) => {
                                      setLine3(e.target.value);
                                      setNotEdited(false);
                                    }}
                                    style={{ width: "100%" }}
                                  />
                                </MDBox>
                              </>
                            )}
                          </MDBox>
                        </Grid>
                      </Grid>
                      <Divider />
                      <MDBox p={2}>
                        <MDButton
                          variant="contained"
                          color="info"
                          onClick={saveOrder}
                          disabled={notEdited}
                          fullWidth
                        >
                          Save Order
                        </MDButton>
                      </MDBox>
                    </MDBox>
                  </Card>
                </>
              ) : (
                <>
                  <MDBox
                    mx={2}
                    mt={-3}
                    py={3}
                    px={2}
                    variant="gradient"
                    bgColor="info"
                    borderRadius="lg"
                    coloredShadow="info"
                  >
                    <MDTypography variant="h6" color="white">
                      No Order Chosen
                    </MDTypography>
                  </MDBox>
                  <Card sx={{ height: "100%", boxShadow: "none" }}>
                    <MDBox pb={2} px={2}>
                      <MDBox py={2}>
                        <MDButton
                          variant="outlined"
                          color="secondary"
                          size="small"
                          onClick={() => {
                            navigate("/orders");
                          }}
                        >
                          <Icon>arrow_back_ios</Icon>
                        </MDButton>
                      </MDBox>
                      <MDTypography variant="h6">You haven&apos;t chosen an order</MDTypography>
                      <MDTypography variant="body2" sx={{ fontSize: ".75rem" }}>
                        Return to the orders page.
                      </MDTypography>
                      <Divider />
                    </MDBox>
                  </Card>
                </>
              )}
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Edit;
